// Shared Turnstile constants safe to import from both client and server.
// Cloudflare test key (always passes) — fallback only.
export const TURNSTILE_TEST_SITE_KEY = "1x00000000000000000000AA";

// RESTORE Hair production Turnstile widget site key (public value).
export const TURNSTILE_SITE_KEY = "0x4AAAAAABgpXEd7XIu2lvbj";